<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../_common/z/ztab.svelte'
    import ComissionsEntries from './comissions-entries.svelte'
    import ComissionsConfigs from './comissions-configs.svelte'
    import Content from '../_common/content.svelte'

    let tabs = [
        {
            title: 'Comissões',
            url: '/comissions/entries',
        },
        {
            title: 'Configurações',
            url: '/comissions/configs',
        },
    ]
    if (!window.store.token.permissions.comissions.configs.write) {
        tabs.splice(1, 1)
    }
</script>

<div class="root-content">
    <Ztab class="mt-2 h-mobile" {tabs} />
    <Content>
        <Router>
            <Route path="/entries">
                <ComissionsEntries />
            </Route>
            <Route path="/configs">
                <ComissionsConfigs />
            </Route>
        </Router>
    </Content>
</div>
